import React from 'react'
import { MdOutlineInsights, MdOutlineMoveUp, MdPlayCircle } from 'react-icons/md'
import { CgSpinner } from 'react-icons/cg'

const baseIconClasses =
  'shrink-0 cursor-pointer rounded-md transition-colors'

const disabledClasses = 'cursor-not-allowed opacity-40'

// Green "play" used to run a workflow step (audit, acknowledge, clearance, ...).
const RunStepIcon = ({
  iconSize = '19',
  onClick,
  title = '',
  disabled = false,
  loading = false,
  className = ''
}) => {
  if (loading) {
    return (
      <span
        title={title}
        className='inline-flex h-6 w-6 items-center justify-center text-success'
      >
        <CgSpinner size={iconSize} className='animate-spin' />
      </span>
    )
  }
  return (
    <MdPlayCircle
      size={iconSize}
      title={title}
      className={`${baseIconClasses} text-success hover:bg-green-50 ${disabled ? disabledClasses : ''} ${className}`}
      onClick={disabled ? undefined : onClick}
      aria-disabled={disabled}
    />
  )
}

// Amber "move to earlier step" action used on batch rows.
const MoveStepIcon = ({
  iconSize = '19',
  onClick,
  title = '',
  disabled = false,
  className = ''
}) => {
  return (
    <MdOutlineMoveUp
      size={iconSize}
      title={title}
      className={`${baseIconClasses} text-amber-500 hover:bg-amber-50 ${disabled ? disabledClasses : ''} ${className}`}
      onClick={disabled ? undefined : onClick}
      aria-disabled={disabled}
    />
  )
}

// Blue "insights/chart" action that opens the current job progress modal.
const JobProgressIcon = ({
  iconSize = '19',
  onClick,
  title = '',
  disabled = false,
  className = ''
}) => {
  return (
    <MdOutlineInsights
      size={iconSize}
      title={title}
      className={`${baseIconClasses} text-blue hover:bg-blue-50 ${disabled ? disabledClasses : ''} ${className}`}
      onClick={disabled ? undefined : onClick}
      aria-disabled={disabled}
    />
  )
}

export { RunStepIcon, MoveStepIcon, JobProgressIcon }
